import { CreateMonitorRequest } from "@/services/backend/qpm/catalog/types/catalog";
import { Label } from "@/shared/components/ui/label";
import t from "@/lang/lang";
import { Input } from "@/shared/components/ui/input";
import { MonitorTypeUtil } from "@/services/backend/qpm/lib/monitor-type-util";
import { TimeNumberInput } from "@/shared/components/inputs/time-number-input";
import {
  MonitorIoTClass,
  MonitorType,
} from "@/services/backend/qpm/types/enums";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";
import { MonitorIoTClassUtil } from "@/services/backend/qpm/lib/monitor-iot-class-util";

export type CreateNewMonitorComponentProps = {
  request: CreateMonitorRequest;
  updateRequest: (request: CreateMonitorRequest) => void;
};

export function CreateNewMonitorComponent({
  request,
  updateRequest,
}: CreateNewMonitorComponentProps) {
  const isIoT = request.monitorType === MonitorType.IoT;
  const defaultProtocolValue = "LoRaWAN";
  const rowClassName =
    "grid grid-cols-[180px_minmax(0,1fr)] items-center gap-2";

  return (
    <div className="flex flex-col gap-2">
      <div className={rowClassName}>
        <Label>{t("Art")}</Label>
        <Input
          value={MonitorTypeUtil.toLongString(request.monitorType)}
          disabled
        />
      </div>
      <div className={rowClassName}>
        <Label>{t("Name")}</Label>
        <Input
          value={request.name}
          onChange={(e) =>
            updateRequest({
              ...request,
              name: e.target.value,
            })
          }
        />
      </div>

      {isIoT ? (
        <>
          <div className={rowClassName}>
            <Label>{t("IoT Typ")}</Label>
            <Select
              value={
                (request.iotClass as unknown as MonitorIoTClass) ?? undefined
              }
              onValueChange={(v) =>
                updateRequest({
                  ...request,
                  iotClass: v as unknown as MonitorIoTClass,
                  iotProtocol: request.iotProtocol ?? defaultProtocolValue,
                })
              }
            >
              <SelectTrigger className="w-full">
                <SelectValue placeholder={t("Bitte auswählen")} />
              </SelectTrigger>
              <SelectContent align="end">
                {Object.values(MonitorIoTClass).map((v) => (
                  <SelectItem key={v} value={v}>
                    {MonitorIoTClassUtil.toLongString(v)}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className={rowClassName}>
            <Label>{t("Protokoll")}</Label>
            <Input
              value={request.iotProtocol ?? defaultProtocolValue}
              onChange={(e) =>
                updateRequest({
                  ...request,
                  iotProtocol: e.target.value,
                })
              }
              onBlur={() => {
                // Ensure we always have a value persisted in request when IoT is active.
                if (!request.iotProtocol) {
                  updateRequest({
                    ...request,
                    iotProtocol: defaultProtocolValue,
                  });
                }
              }}
              placeholder={defaultProtocolValue}
            />
          </div>
        </>
      ) : null}

      <div className={rowClassName}>
        <Label>{t("Installationszeit")}</Label>
        <TimeNumberInput
          value={request.install}
          onChange={(e) =>
            updateRequest({
              ...request,
              install: e,
            })
          }
        />
      </div>
      <div className={rowClassName}>
        <Label>{t("Servicezeit")}</Label>
        <TimeNumberInput
          value={request.maintain}
          onChange={(e) =>
            updateRequest({
              ...request,
              maintain: e,
            })
          }
        />
      </div>
    </div>
  );
}
